import { render, staticRenderFns } from "./LettersAvatar.vue?vue&type=template&id=84aecc74&scoped=true&"
import script from "./LettersAvatar.vue?vue&type=script&lang=js&"
export * from "./LettersAvatar.vue?vue&type=script&lang=js&"
import style0 from "./LettersAvatar.vue?vue&type=style&index=0&id=84aecc74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aecc74",
  null
  
)

export default component.exports